import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { AssignmentDto } from '../../generated/backend';
import {
  isFarAway,
  isMainPrimeLogisticAssignment,
  isMiOk,
  isMiProbSolutions,
  isMiWarning,
} from '../../util/assignment-extended';
import { BadgeVariantComponent, Shape } from '../badge-variant/badge-variant/badge-variant.component';

/**
 * Presentational cell that renders the "info" badges for an assignment row:
 * far-away, Mission-Impossible (warning / ok / problem-solutions) and the
 * Prime Logistic shield.
 *
 * Extracted so the assignment list grid and the assignment data grid render
 * these badges identically from a single source of truth.
 */
@Component({
  selector: 'app-assignment-info-badges',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateModule, BadgeVariantComponent],
  templateUrl: './assignment-info-badges.component.html',
})
export class AssignmentInfoBadgesComponent {
  readonly Shape = Shape;

  /** The assignment row to render badges for. */
  readonly assignment = input.required<AssignmentDto & { TransportLabel?: string }>();

  readonly farAway = computed(() => isFarAway(this.assignment()));
  readonly miWarning = computed(() => isMiWarning(this.assignment()));
  readonly miOk = computed(() => isMiOk(this.assignment()));
  readonly miProbSolutions = computed(() => isMiProbSolutions(this.assignment()));
  readonly mainPrimeLogistic = computed(() => isMainPrimeLogisticAssignment(this.assignment()));
}
